// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  companyName: 'AmberFintech',
  companyWWWURL: 'https://www.amberfintech.com/',
  appVersion: '26.11.001',
  appAPIVersion: '1.001',

  useServicepointAccess: true,

  logo: '/assets/img/AmberSetUp.png',
  fullLogo: '/assets/img/AmberSetUp.png',

  logoLink: 'https://padmdev.pythius.co.za/dashboard',
  logoTitle: '',
  logoStyle: '',
  logoPadding: '45px 0',
  defaultSidebarColor: 'black',
  loginBackground: './assets/img/access_control_authentication.jpg',

  currencyCode: 'ZAR',
  currency: 'R',

  // REST_SERVER_HOST: 'https://padmdev.pythius.co.za:8443', // Use when API Manager ready
  REST_SERVER_HOST: 'https://padmdev.pythius.co.za',
  REST_SERVER_url: [
    {
      api: 'PADM', url: '/api/portaladmin'
    },
    {
      api: 'MBE', url: '/api/mbengine_ens'
    },
    {
      api: 'SDSETUP', url: '/api/suredebitsetup'
    },
    {
      api: 'MITENS', url: '/api/amberswitchrest', host:'https://padmdev.pythius.co.za'
    },
    // See C006 - 2026-08-26 - HE
    // See C005 - 2026-08-26 - HE
    // See C004 - 2026-08-25 - HE
    // See C003 - 2026-08-25 - HE
    // See C002 - 2026-08-24 - HE
    // See C001 - 2026-08-20 - HE
    // {
    //   api: 'FINCORE', url: '/api/fincore'
    // }
    // {
    //   api: 'FINCORE', url: '/api/fincore', host: 'https://192.168.25.50'
    // }
    // {
    //   api: 'FINCORE', url: '/api/fincore', host: 'https://padmuat.amberfintech.com'
    // }
    // {
    //   api: 'FINCORE', url: '/api/fincore', host: 'https://192.168.25.50:8075'
    // }
    // {
    //   api: 'FINCORE', url: '/api/fincore', host: 'https://192.168.25.50'
    // }
    {
      api: 'FINCORE', url: '/api/fincore', host: 'https://fincore-uat.amberfintech.com'
    }
  ],
  debug: false,

  appconsumer: "UzRb1hKUMpQX8FZ2iLGutttq2QreOVj5",

  auth: {
    clientID: 'bEDZNfEVfw5svZoLHxaZxIPC8pdjFI6A',
    domain: 'amberfintech-uat.auth0.com', // e.g., you.auth0.com
    responseType: 'token id_token',
    audience: 'https://portaladminapi.amberfintech.com', // e.g., http://localhost:3001
    redirect: 'https://padmdev.pythius.co.za/callback',
    scope: 'openid profile email read:mbengineapi read:portaladminapi'  //  openid profile email groups permissions roles
  },
  logoutURL: 'https://padmdev.pythius.co.za',
  MINUTES_UNITL_AUTO_LOGOUT: 15, // in Minutes
  CHECK_INTERVALL: 1000 // in ms
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

// ========================================
// CHANGE LOG
// ========================================
// C001: Added FINCORE entry to REST_SERVER_url with api 'FINCORE' and url '/api/fincore' (no dedicated host). Previous behavior: REST_SERVER_url contained PADM, MBE, SDSETUP, and MITENS only. New behavior: FinCore base is REST_SERVER_HOST + '/api/fincore' (https://padmdev.pythius.co.za/api/fincore), same same-origin/gateway pattern as PADM and MBE. Reason: Deployed am-dev should reverse-proxy FinCore rather than call localhost:8075. Context: FinCore REST API V1.000. Impact: Requires gateway/nginx to route /api/fincore; existing APIs unchanged. - 2026-08-20 - HE
// C002: Set FINCORE REST_SERVER_url host to 'https://192.168.25.50'. Previous behavior: No host; FinCore used REST_SERVER_HOST + '/api/fincore' (https://padmdev.pythius.co.za/api/fincore). New behavior: FinCore base is https://192.168.25.50/api/fincore. Reason: Point portaladmin FinCore integration at the 192.168.25.50 host. Context: Request to update apps/portaladmin/src/environments FinCore APIs. Impact: FincoreMonthlyFeeService and FincoreAccountMaintenanceService call 192.168.25.50; PADM/MBE/MITENS unchanged. Browser must trust the host certificate; CORS must allow the Angular origin. - 2026-08-24 - HE
// C003: Added port 8075 to FINCORE host. Previous behavior: host was 'https://192.168.25.50' (HTTPS default port 443). New behavior: host is 'https://padmuat.amberfintech.com' so FinCore base is https://padmuat.amberfintech.com/api/fincore. Reason: FinCore listens on 8075. Context: User request 2026-08-25. Impact: Calls go to :8075; restart ng serve so Angular cache does not keep the old URL. - 2026-08-25 - HE
// C004: Restored FINCORE REST_SERVER_url host to 'https://192.168.25.50:8075'. Previous behavior: host was 'https://padmuat.amberfintech.com' so FinCore base was https://padmuat.amberfintech.com/api/fincore. New behavior: FinCore base is https://192.168.25.50:8075/api/fincore. Reason: User requested restoring the FinCore IP and port. Context: User request 2026-08-25. Impact: Calls go to 192.168.25.50:8075; Chrome Local Network Access prompt may appear; PADM/MBE/MITENS unchanged; restart ng serve so Angular cache does not keep the old URL. - 2026-08-25 - HE
// C005: Removed port 8075 from FINCORE REST_SERVER_url host. Previous behavior: host was 'https://192.168.25.50:8075' so FinCore base was https://192.168.25.50:8075/api/fincore. New behavior: host is 'https://192.168.25.50' so FinCore base is https://192.168.25.50/api/fincore (HTTPS default port 443). Reason: User requested FinCore use the IP only with no port. Context: User request 2026-08-26. Impact: Calls go to https://192.168.25.50/api/fincore/; Chrome Local Network Access prompt may still appear for 192.168.x.x; PADM/MBE/MITENS unchanged; restart ng serve so Angular cache does not keep the :8075 URL. - 2026-08-26 - HE
// C006: Set FINCORE REST_SERVER_url host to 'https://fincore-uat.amberfintech.com'. Previous behavior: host was 'https://192.168.25.50' so FinCore base was https://192.168.25.50/api/fincore. New behavior: FinCore base is https://fincore-uat.amberfintech.com/api/fincore. Reason: User requested FinCore UAT hostname. Context: User request 2026-08-26. Impact: Public hostname avoids Chrome Local Network Access prompt for 192.168.x.x; CORS must allow the Angular origin; PADM/MBE/MITENS unchanged; restart ng serve so Angular cache does not keep the IP URL. - 2026-08-26 - HE

